import type { FC } from 'react';
import { lazy } from 'react';
import { useParams } from 'react-router-dom';
import type { FinancialSecurityType } from 'src/apis/contract-management/types';
import { useContractManagement } from 'src/apis/contract-management/use-contract-management';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const FinancialSecurityAssociateForm: FC<{
  type: FinancialSecurityType;
}> = ({ type }) => {
  const { financialSecurityId } = useParams<{ financialSecurityId: string }>();
  const contractManagementRoot = useContractManagement();
  if (!contractManagementRoot.response) return <PageSpinner />;

  return (
    <Page
      financialSecurityId={financialSecurityId}
      type={type}
      contractManagement={contractManagementRoot.response.data}
    />
  );
};
